import PropTypes from 'prop-types';
import React from 'react';
import { Row } from 'reactstrap';
import {
    Data,
    Item,
    StyledCol,
    Title,
    Wrapper
} from './styled';

const InnerCard = ({
    data = []
}) => (
    <Row>
        {
            data.map(({
                fontWeight = '500',
                label,
                value,
                visible = true
            }) => {
                if (!visible) return null;
                return (
                    <StyledCol key={ label } md="4">
                        <Wrapper>
                            <Item>
                                <Title>{`${ label }:`}</Title>
                                <Data fontWeight={ fontWeight }>
                                    { value !== null && value !== undefined && value !== '' ? value : 'n/d' }
                                </Data>
                            </Item>
                        </Wrapper>
                    </StyledCol>
                );
            }
            )
        }
    </Row>
);

InnerCard.propTypes = {
    data: PropTypes.array
};

export default InnerCard;
